// Buyer SPA i18n wiring. Imports the shared i18n singleton (which self-initializes
// react-i18next's global instance) and registers this app's per-area namespaces
// onto it. Import this module once from main.tsx BEFORE the first render.
//
// One namespace per UI area; each maps to a JSON bundle under ./locales/en/.
// Components read their namespace explicitly, e.g. `useTranslation("stages")`.
// Keeping one file per namespace keeps ownership legible and diffs small.

// `@recruiter/shared/i18n`, NOT the package barrel. This module is web's vitest
// `setupFiles` entry, so it is evaluated once per TEST FILE — and the barrel drags in
// every shared component (React, Base UI, the whole UI surface) with it. Loading that
// 155 times cost 105s of the suite's 360s while the assertions themselves ran for 17s.
// The i18n subpath is i18next + one JSON. Keep this import narrow.
import { registerNamespace } from "@recruiter/shared/i18n";

import enAgent from "./locales/en/agent.json";
import enApp from "./locales/en/app.json";
import enBlocks from "./locales/en/blocks.json";
import enBrief from "./locales/en/brief.json";
import enFiles from "./locales/en/files.json";
import enLib from "./locales/en/lib.json";
import enPrint from "./locales/en/print.json";
import enProfile from "./locales/en/profile.json";
import enResults from "./locales/en/results.json";
import enSms from "./locales/en/sms.json";
import enStages from "./locales/en/stages.json";
import enUi from "./locales/en/ui.json";
import enVoice from "./locales/en/voice.json";
import enWorkspace from "./locales/en/workspace.json";

const BUNDLES: Record<string, Record<string, unknown>> = {
  agent: enAgent,
  app: enApp,
  blocks: enBlocks,
  brief: enBrief,
  files: enFiles,
  lib: enLib,
  print: enPrint,
  profile: enProfile,
  results: enResults,
  sms: enSms,
  stages: enStages,
  ui: enUi,
  voice: enVoice,
  workspace: enWorkspace,
};

for (const [namespace, bundle] of Object.entries(BUNDLES)) {
  registerNamespace(namespace, bundle);
}

/** The namespaces this app owns. Exported for tests / typing. */
export const WEB_NAMESPACES = Object.keys(BUNDLES);
